import * as Yup from 'yup'

export const ContractorPortalUpdatePhoneEnterCodeModalSchema = Yup.object().shape({
  // @ts-ignore
  code: Yup.string().required('Verification code is required'),
})
